import React from 'react';
import { FailedDelivery } from '../driverFailedDeliveriesTypes';
import styles from './FailedDeliveryCard.module.css';

interface FailedDeliveryCardProps {
  delivery: FailedDelivery;
  onRetry?: (id: string) => void;
  onContact?: (id: string) => void;
}

export const FailedDeliveryCard: React.FC<FailedDeliveryCardProps> = ({
  delivery,
  onRetry,
  onContact,
}) => {
  const variant = delivery.status === 'Failed' ? 'failed' : 'retry';

  return (
    <div className={`${styles.card} ${styles[variant]}`}>
      <div className={styles.headerRow}>
        <div>
          <p className={styles.store}>{delivery.storeName}</p>
          <p className={styles.address}>{delivery.address}</p>
        </div>
        <span className={`${styles.badge} ${styles[`badge_${variant}`]}`}>
          {delivery.status}
        </span>
      </div>

      <div className={styles.reasonBox}>
        <p className={styles.reasonTitle}>REASON: {delivery.reason}</p>
        <p className={styles.reasonText}>{delivery.description}</p>
      </div>

      {delivery.status === 'Failed' && (
        <div className={styles.actions}>
          <button className={styles.retryBtn} onClick={() => onRetry?.(delivery.id)}>
            Schedule Retry
          </button>
          <button className={styles.contactBtn} onClick={() => onContact?.(delivery.id)}>
            Contact Support
          </button>
        </div>
      )}

      {delivery.retryScheduled && (
        <p className={styles.retryNote}>{delivery.retryScheduled}</p>
      )}
    </div>
  );
};
